import userApi from '@/api/user.api'

class UserController {
  async fetchMe() {
    const { data } = await userApi.getMe()
    return data
  }
}

export const userController = new UserController()
